<div class="p-grid" style="width: 100%;">
    <div class="p-col-12">
        <p-multiSelect [appendTo]="'body'" [tooltipPosition]="'left'" [disabled]="cq" defaultLabel="Motifs" [style]='{"width": "100%"}' [options]="errors" [(ngModel)]="selectedErrors" (ngModelChange)="errorChanged(selectedErrors)"></p-multiSelect>
    </div>
</div>
